export default __webpack_public_path__ + "static/media/tools.d35bd566.svg";